import { Stack } from "@mui/material";
import { Button } from "@src/appV2/redesign/components/Button";
import { CbhIcon, type IconType, Text } from "@src/appV2/redesign/system/ui-components";
import { type ReactNode } from "react";

interface ScreeningSurveyInfoLayoutProps {
  title: string;
  icon: IconType;
  action?: {
    label: string;
    onClick: () => void;
  };
  children: ReactNode;
}

export function ScreeningSurveyInfoLayout(props: ScreeningSurveyInfoLayoutProps) {
  const { title, icon, action, children } = props;

  return (
    <Stack sx={{ height: "100%", padding: 8 }}>
      <Stack sx={{ flex: 1 }} spacing={4} justifyContent="center">
        <CbhIcon type={icon} sx={{ alignSelf: "center", width: 200, height: 200 }} />
        <Text bold variant="h1" sx={{ textAlign: "center", paddingTop: 6 }}>
          {title}
        </Text>
        {children}
      </Stack>
      {action && (
        <Button fullWidth variant="contained" sx={{ paddingY: 1.5 }} onClick={action.onClick}>
          {action.label}
        </Button>
      )}
    </Stack>
  );
}
